import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {HttpService} from '@/services/api';
import {CommunityEnumApi} from '@/store/community/community.enum';
import {Community, CommunityInitState, FilterCommunity, ResponseCommunity} from '@/store/community/community.types';

export const CommunityAction: ActionTree<CommunityInitState, RootState> = {
  async _getCommunity(req: ActionContext<CommunityInitState, RootState>, filter?: FilterCommunity): Promise<void> {
    let {commit} = req;
    try {
      let community = await HttpService.get(CommunityEnumApi.community, filter) as { data: ResponseCommunity };
      if (community.data.appCode === 20000) {
        commit('mutationGetCommunity', community.data.data);
        commit('mutationTotalCommunity', community.data.total);
      } else {
        commit('mutationGetCommunity', []);
      }
    } catch (e) {
      commit('mutationGetCommunity', []);
      console.error('DEBUG: _getCommunity ', e.message);
    }
  },
  async _getCommunityAlready(req: ActionContext<CommunityInitState, RootState>, params?: Community): Promise<void> {
    let {commit} = req;
    try {
      let community = await HttpService.get(`${CommunityEnumApi.community}is-already`, params) as { data: ResponseCommunity };
      if (community.data.appCode === 20000) {
        commit('mutationGetCommunity', community.data.data);
      } else {
        commit('mutationGetCommunity', []);
      }
    } catch (e) {
      commit('mutationGetCommunity', []);
      console.error('DEBUG: _getCommunity ', e.message);
    }
  },
  async _getCommunityAlreadyByBranch(req: ActionContext<CommunityInitState, RootState>, params?: string): Promise<void> {
    let {commit} = req;
    try {
      let community = await HttpService.get(`${CommunityEnumApi.community}is-already/${params}`, params) as { data: ResponseCommunity };
      if (community.data.appCode === 20000) {
        commit('mutationGetCommunity', community.data.data);
      } else {
        commit('mutationGetCommunity', []);
      }
    } catch (e) {
      commit('mutationGetCommunity', []);
      console.error('DEBUG: _getCommunity ', e.message);
    }
  },
  async _insertCommunity(req: ActionContext<CommunityInitState, RootState>, payload: Community): Promise<void> {
    try {
      let {dispatch} = req;
      let res = await HttpService.post(CommunityEnumApi.community, payload);
      await dispatch('_getCommunity');
      return res;
    } catch (e) {
      console.error('DEBUG: _insertCommunity ', e.message);
    }
  },
  async _updateCommunity(req: ActionContext<CommunityInitState, RootState>, payload: Community): Promise<void> {
    try {
      let {dispatch} = req;
      let res = await HttpService.put(CommunityEnumApi.community, payload);
      await dispatch('_getCommunity');
      return res;
    } catch (e) {
      console.error('DEBUG: _updateCommunity ', e.message);
    }
  },
  async _deleteCommunity(req: ActionContext<CommunityInitState, RootState>, payload: string): Promise<void> {
    try {
      let {dispatch} = req;
      let res = await HttpService.delete(`${CommunityEnumApi.community}branch/`, payload);
      await dispatch('_getCommunity');
      return res;
    } catch (e) {
      console.error('DEBUG: _deleteCommunity ', e.message);
    }
  },
  async _getCommunityForRegister(req: ActionContext<CommunityInitState, RootState>, filter?: FilterCommunity): Promise<void> {
    let {commit} = req;
    try {
      let community = await HttpService.get(`${CommunityEnumApi.community}register`, filter) as { data: ResponseCommunity };
      if (community.data.appCode === 20000) {
        commit('mutationGetCommunity', community.data.data);
        commit('mutationTotalCommunity', community.data.total);
      } else {
        commit('mutationGetCommunity', []);
      }
    } catch (e) {
      commit('mutationGetCommunity', []);
      console.error('DEBUG: _getCommunity ', e.message);
    }
  },
};
